import MemberEntity from '../entities/Member';

export type State = MemberEntity;
const initialState: State = {} as MemberEntity;

const Account = (state: State = initialState, action: any) => {
  switch (action.type) {
    case 'REMEMBER_SIGNIN_MEMBER':
    case 'SUCCESS_SIGNIN_MEMBER':
    case 'SUCCESS_CREATE_MEMBER':
      return action.member;

    case 'SUCCESS_UPDATE_ACCOUNT':
      return action.member;
  }

  return state;
};

export default Account;



// WEBPACK FOOTER //
// ./src/reducers/Account.ts